// import $ from 'jquery'
import axios from "axios";
import Header from "../../../components/Header.vue";
// import moment from "moment";


// import moment from 'moment'

export default {
    components: {
        Header

    },
    data: function() {
        return {
            pageTitle: "Tableau de Bord",
            dateOptions: {
                format: 'DD/MM/YYYY',
                useCurrent: false,
            },
            filtre:{
                date_debut: '',
                date_fin: '',
                recherche: '',
                criteriacol: '',
                per_page: 20,
                current_page: 1
            },
            data:[],
            data_parent: {},
        }
    },

    methods: {
        getData(){
            let formulaire = new FormData();
            formulaire.append('date_debut',this.filtre.date_debut);
            formulaire.append('date_fin',this.filtre.date_fin);
            formulaire.append('recherche',this.filtre.recherche);
            formulaire.append('criteriacol',this.filtre.criteriacol);
            formulaire.append('current_page',this.filtre.current_page);
            formulaire.append('per_page',this.filtre.per_page);
            axios.post(this.BASE_URL + '/suivietresorerie/recapsuivie',formulaire).then((response) => {
                this.data = response.data.data;
                this.data_parent = response.data.data_parent;
            })
        },
        setFilter() {
            this.getData();
        },
        resetFilter() {
            this.filtre={
                date_debut: '',
                date_fin: '',
                recherche: '',
                criteriacol: '',
            }
            this.setFilter();
        },


        prevPage() {
            if (this.filtre.current_page > 1) {
                this.filtre.current_page--;
                this.getData();
            }
        },


        nextPage() {
            if (this.filtre.current_page < this.data_parent.last_page) {
                this.filtre.current_page++;
                this.getData();
            }
        },

        goToPage(page) {
            if (page >= 1 && page <= this.data_parent.last_page) {
                this.filtre.current_page = page;
                this.getData();
            }
        }
    },

    created: function() {
        this.$emit('change-page', this.pageTitle);
        this.motCle = "";
        this.criteriacol = "";

    },
    computed: {
        paginationRange() {
            const total = this.data_parent.last_page || 1;
            const current = this.filtre.current_page;
            const delta = 2;
            let range = [];
            let rangeWithDots = [];
            let l;

            for (let i = 1; i <= total; i++) {
                if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
                    range.push(i);
                }
            }

            for (let i of range) {
                if (l) {
                    if (i - l === 2) {
                        rangeWithDots.push(l + 1);
                    } else if (i - l !== 1) {
                        rangeWithDots.push('...');
                    }
                }
                rangeWithDots.push(i);
                l = i;
            }

            return rangeWithDots;
        }
    },


    mounted: function() {
        this.getData();
    }
}
